import { render, staticRenderFns } from "./ortala_dokumen.vue?vue&type=template&id=1e65c218&"
import script from "./ortala_dokumen.vue?vue&type=script&lang=js&"
export * from "./ortala_dokumen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports